// extracted by mini-css-extract-plugin
export default {"sticky_button":"FinalizeButton_sticky_button__oG29i","total_box":"FinalizeButton_total_box__8Wnzo"};